import { Link, useSearchParams } from 'react-router-dom'
import UserFrame from "../organisms/UserFrame";
import UMIndex from "../molecules/UMIndex";
import { Container, Box, Grid, AppBar, Typography, Checkbox, Radio, Button, Stack, Modal, List, ListItem, IconButton, ListItemButton, ListItemIcon, ListItemText, Chip, Divider, ToggleButtonGroup, ToggleButton, Accordion, AccordionSummary, AccordionDetails, LinearProgress} from '@mui/material';
import { useEffect, useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ErrorIcon from '@mui/icons-material/Error';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import CancelIcon from '@mui/icons-material/Cancel';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import DoughnutChart from '../atoms/Doughnut';
import axios from 'axios';

// 定数
const allowed = [8, 9, 10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31];

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '1px solid #aaa',
    boxShadow: 24,
    p: 4,
  };

type Props = {
    practices: PracticeType[],
    tests: TestType[],
    questionBook: number,
    userId: number
}

export type PracticeType = {
    practiceId: number,
    practiceName: string,
    triedCount: number
}

export type ChoiceType = {
    choiceNum: number,
    choiceText: string,
    isCorrect: boolean
}

export type TestType = {
    testId: number,
    question: string,
    choices: ChoiceType[],
    answer: number[],
    explanation: string,
}


/** user 資料 */
const UserTestTemplate = (props: Props) => {
    const {practices, tests, questionBook, userId} = props;
    const [searchParams] = useSearchParams();
    const practice = practices.find(p => p.practiceId === Number(searchParams.get("no") ?? '-1'))
    let nextId: null | number = null;
    let curFlg = false;
    practices?.forEach((p, idx) => {
        if (idx + 1 < practices?.length && curFlg) {
            nextId = p.practiceId;
            curFlg = false;
        } else if (p.practiceId === practice?.practiceId) {
            curFlg = true;
        }
    })
    const now = new Date();
    const [startTime, setStartTime] = useState(now.getTime());
    const testTime = 2 * 60 * 60 * 1000 + 10 * 60 * 1000;
    const [endTime, setEndTime] = useState(0);
    const [phase, setPhase] = useState<'test'|'result'|'exp'>('test');
    const [side, setSide] = useState<'practices'|'tests'>('practices')
    const [tryingNo, setTryingNo] = useState(0);
    const [selectedCoice, setSelectedChoice] = useState<number[]>([]);
    const ua: number[][] = [];
    for (let i = 0; i < tests?.length; i++) {
        ua.push([]);
    }
    const [userAnswers, setUserAnswers] = useState<number[][]>(ua);
    const [score, setScore] = useState(0);
    const [results, setResults] = useState<boolean[]>([]);
    const [isSent, setIsSent] = useState(false);

    const [open, setOpen] = useState(false);
    const handleClose = () => setOpen(false);

    
    const [expList, setExpList] = useState<{no: Number, test: TestType, answer: number[], isCorrect: boolean}[]>([]);
    const [expanded, setExpanded] = useState<boolean[]>([]);
    const createExpList = (pattern: string | null) => {
        const tmpExpList: {no: Number, test: TestType, answer: number[], isCorrect: boolean}[] = [];
        tests?.forEach((t, idx) => {
            if (
                (pattern === 'all' || pattern === null)
                || (pattern === 'correct' && results[idx])
                || (pattern === 'incorrect' && !results[idx])
                || (pattern === 'unanswered' && userAnswers[idx]?.length === 0)
            ) {
                tmpExpList.push({no: idx, test: t, answer: userAnswers[idx], isCorrect: results[idx]});
            }
            setExpList(tmpExpList);
            const tmp: boolean[] = Array(tmpExpList?.length);
            tmp.fill(true);
            setExpanded(tmp);
        })
    }

    const [alignment, setAlignment] = useState<string | null>('all');
    const handleAlignment = (
        event: React.MouseEvent<HTMLElement>,
        newAlignment: string | null,
    ) => {
        setAlignment(newAlignment);
        createExpList(newAlignment);
    };

    const selectChoice = (num: number) => {
        if (tests[tryingNo].answer?.length === 1) {
            //radio
            setSelectedChoice([num]);
        } else {
            //check box
            if (selectedCoice?.includes(num)) {
                const tmpCoices = selectedCoice?.filter(s => s !== num);
                setSelectedChoice(tmpCoices);
            } else if (selectedCoice?.length > 0) {
                setSelectedChoice([...selectedCoice, num])
            } else {
                setSelectedChoice([num]);
            }
        }
    }

    const goNext = () => {
        const tmpAnswers: number[][] = [];
        for (let i = 0; i < tests?.length; i++) {
            if (i === tryingNo) {
                tmpAnswers.push(selectedCoice);
            } else {
                tmpAnswers.push(userAnswers[i])
            }
        } 
        setUserAnswers(tmpAnswers);
        setTryingNo(tryingNo + 1)
    }
    const goBack = () => {
        setTryingNo(tryingNo - 1)
    }

    useEffect(() => {
        setSelectedChoice(userAnswers[tryingNo]);
    }, [tryingNo])


    // 回答送信
    const updateUserQuestion = async(score: number, ) => {
        await axios.post(process.env.REACT_APP_BE_HOST + 'workbooks/updateUserQuestion', {
            "questionBook": questionBook,
            "userId": userId,
            "score": score,
            "time": `${Math.floor(endTime/3600000)}:${Math.floor((endTime%3600000)/60000).toString().padStart(2, '0')}:${Math.floor((endTime%60000)/1000).toString().padStart(2, '0')}`
        }, {
            withCredentials: true
        })
        .then((res: any) => {
            setIsSent(true);
        })
    }

    useEffect(() => {
        if (!isSent && phase === 'result') {
            // 採点
            const resultList: {id: number, isCorrect: boolean}[] = [];
            tests?.forEach((t,index) => {
                let isCorrect = true
                t.answer?.forEach(a => {
                    if (!userAnswers[index]?.includes(a)) isCorrect = false;
                })
                userAnswers[index]?.forEach(u => {
                    if (!t.answer?.includes(u)) isCorrect = false;
                })
                resultList.push({id: t.testId, isCorrect})
            })
            resultList.sort((a,b) => {
                return a.id < b.id ? -1 : 1;
            })
            const tmpResults: boolean[] = [];
            let tmpScore = 0;
            resultList?.forEach(r => {
                tmpResults.push(r.isCorrect);
                if (r.isCorrect) tmpScore++;
            });
            
            setResults(tmpResults);
            setScore(tmpScore);
            updateUserQuestion(tmpScore)
        }
    }, [phase])

    useEffect(() => {
        if(results?.length > 0) {
            createExpList('all');
        }
    }, [results])


    const [progress, setProgress] = useState(0);
    const [leftTime, setLeftTime] = useState("");

    useEffect(() => {
        const timer = setInterval(() => {
            // 固定問題以外の場合
            if (!allowed.includes(questionBook)) {
                setProgress((oldProgress) => {
                    const pt = new Date().getTime() - startTime;
                    if (phase === 'test') {
                        setEndTime(pt);
                        if (oldProgress === 100) {
                            setEndTime(testTime);
                            setPhase("result");
                        }
                    }
                    const left = pt / testTime * 100;
                    const lt = testTime - pt + 1000;
                    setLeftTime(`${Math.floor(lt/3600000)}:${Math.floor((lt%3600000)/60000).toString().padStart(2, '0')}:${Math.floor((lt%60000)/1000).toString().padStart(2, '0')}`)

                    return Math.min(left, 100);
                });
            }
        }, 1000);
            

        return () => {
            if (!allowed.includes(questionBook)) {
                clearInterval(timer);
            }
        };
    }, []);

    return (
        <UserFrame title={practice?.practiceName ?? ''}>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        終了しますか？
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                        {userAnswers?.filter(a => a?.length === 0)?.length > 0 ?
                            `${userAnswers?.filter(a => a?.length === 0)?.length}問スキップしました。`
                            :
                            "まだ入力した問題を見直すことができます。"
                        }
                    </Typography>
                    <Box mt={2}>
                        <div style={{display: 'inline-block', float: 'right'}}>
                            <Button sx={{mr:2}} onClick={()=>setOpen(false)}>問題を見直す</Button>
                            <Button
                                onClick={() => {
                                    setPhase('result');
                                    setOpen(false);
                                }}
                                variant='contained'
                            >
                                テストを完了する
                            </Button>
                        </div>
                    </Box>
                </Box>
            </Modal>

            <Grid container>
                <Grid item xs={12} md={8}>
                <Container maxWidth='lg'>
                    <Box sx={{padding: 1}}>
                        <Box overflow='scroll' sx={{height: '480px'}} px={2}>
                            {phase === 'test' && <>
                                <Stack direction={'row'}>
                                    <Box p={2}>{tryingNo + 1}/{tests?.length}</Box>
                                    <Box mt={3.4} width={"50%"}>
                                        <LinearProgress variant="determinate" value={progress} />
                                    </Box>
                                    <Box pt={2} pl={2}><AccessTimeIcon/></Box>
                                    <Box pt={1.9} pl={1}>{leftTime}</Box>
                                    <Box m={1}>
                                        <Button
                                            onClick={()=> {
                                                const tmpAnswers: number[][] = [];
                                                for (let i = 0; i < tests?.length; i++) {
                                                    if (i === tryingNo) {
                                                        tmpAnswers.push(selectedCoice);
                                                    } else {
                                                        tmpAnswers.push(userAnswers[i])
                                                    }
                                                } 
                                                setUserAnswers(tmpAnswers);
                                                setOpen(true);
                                            }}
                                        >
                                            テストを完了する
                                        </Button>
                                    </Box>
                                </Stack>
                                <Box>☆問題{tryingNo+1}:</Box>
                                <Box py={1}>{tests[tryingNo].question}</Box>
                                {tests[tryingNo].choices && tests[tryingNo].choices?.map((c, idx) => 
                                    <Box
                                        key={`choice_${idx}`}
                                        border={2}
                                        borderColor={'lightGrey'}
                                        p={1}
                                        my={1}
                                        onClick={()=>{
                                            selectChoice(idx)
                                        }}
                                    >
                                        {tests[tryingNo].answer?.length > 1 ? <Checkbox
                                            disabled
                                            checked={selectedCoice?.includes(idx)}
                                            key={`c${idx}_${String(selectedCoice)}`}
                                        />
                                        :
                                        <Radio
                                            disabled
                                            checked={idx === selectedCoice[0]}
                                            key={`r${idx}_${String(selectedCoice)}`}
                                        />}
                                        {c.choiceText}
                                    </Box>
                                )}
                            </>}
                            {phase === 'result' && <>
                                <Box mb={1}>
                                    <Typography id="modal-modal-title" variant="h6" component="h2">
                                        {practice?.practiceName +` - 結果`}
                                    </Typography>
                                </Box>
                                <Divider/>
                                <Box my={2}>
                                    {tests?.length}問｜2時間10分｜正解率72%以上で合格
                                </Box>
                                <Stack direction={'row'} border={1} borderColor={'#ccc'}>
                                    <Box width={'400px'} p={2}>
                                        <DoughnutChart data={[score, tests?.length - score]}/>
                                    </Box>
                                    <Box p={2} mt={5}>
                                        <Stack direction={'row'}>
                                            <Typography mr={1}>{`${practice?.triedCount ? practice?.triedCount + 1 : 1}回目:`}</Typography>
                                            <Typography color={score / tests?.length < 0.72 ? '#f59787' : '#4dd385'}>
                                                {score / tests?.length < 0.72 ? '不合格' : '合格'}{`(72%以上で合格)`}
                                            </Typography>
                                        </Stack>
                                        <Stack direction={'row'} my={2}>
                                            <Typography mr={1} variant="h4">{`${Math.floor(score / tests?.length * 100)}%`}</Typography>
                                            <Typography mt={2}>
                                                {`正解 (${score}/${tests?.length})`}
                                            </Typography>
                                        </Stack>
                                        <Typography>
                                            {endTime > 60 * 60 * 1000 ?
                                            `${Math.floor(endTime/3600000)}時間${Math.floor((endTime%3600000)/60000)}分`
                                            : `${Math.floor((endTime%3600000)/60000)}分`
                                            }
                                        </Typography>
                                        <Typography>
                                            {`${now.getFullYear()}年${now.getMonth()+1}月${now.getDate()}日`}
                                        </Typography>
                                        <Button sx={{marginTop: '2rem'}} variant='outlined' onClick={()=>setPhase('exp')}>
                                            問題を見直す
                                        </Button>
                                    </Box>
                                </Stack>
                            </>}
                            {phase === 'exp' && <>
                            <Box mb={14}>
                                <Box mb={1}>
                                    <Typography id="modal-modal-title" variant="h6" component="h2">
                                        {practice?.practiceName +` - 結果`}
                                    </Typography>
                                </Box>
                                <Divider/>
                                <Button onClick={()=>setPhase('result')}>{`< 結果の概要に戻る`}</Button>
                                <Typography mt={1} variant="h6">{`試行${practice?.triedCount ? practice?.triedCount + 1 : 1}`}</Typography>
                                <div style={{display: 'inline-block', float: 'right'}}>
                                    <Box mb={2}>
                                        <ToggleButtonGroup
                                            value={alignment}
                                            exclusive
                                            onChange={handleAlignment}
                                        >
                                            <ToggleButton value="all">
                                                {`${tests?.length} すべて`}
                                            </ToggleButton>
                                            <ToggleButton value="correct">
                                                {`${score} 正解`}
                                            </ToggleButton>
                                            <ToggleButton value="incorrect">
                                                {`${tests?.length - score} 不正解`}
                                            </ToggleButton>
                                            <ToggleButton value="unanswered">
                                                {`${userAnswers?.filter(a => a?.length === 0)?.length ?? 0} 未回答`}
                                            </ToggleButton>
                                        </ToggleButtonGroup>
                                    </Box>
                                    <div style={{display: 'inline-block', float: 'right'}}>
                                        <Button
                                            onClick={() => {
                                                const tmp: boolean[] = Array(expList?.length);
                                                tmp.fill(false);
                                                setExpanded(tmp);
                                            }}
                                        >
                                            全ての問題を折りたたむ
                                        </Button>
                                    </div>
                                </div>
                            </Box>
                            <Box>
                                {expList && expList?.map((l, idx) => <Accordion
                                    key={`answer_${idx}`}
                                    expanded={expanded[idx]}
                                    onChange={() => {
                                        const tmp: boolean[] = [];
                                        expanded?.forEach((e, i) => {
                                            if (i === idx) {
                                                tmp.push(!expanded[i]);
                                            } else {
                                                tmp.push(expanded[i]);
                                            }
                                        })
                                        setExpanded(tmp);
                                    }}
                                >
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        id={`acc_${idx}`}
                                    >
                                        {l.isCorrect ? <span style={{width: '24px'}}/> : <ErrorIcon color='error'/>}
                                        {`問題${Number(l.no) + 1}　`}
                                        {l.isCorrect ?
                                            <Typography color={'#4dd385'}>正解</Typography>
                                            : <Typography color={'#f59787'}>不正解</Typography>
                                        }
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Box ml={'24px'}>{l.test.question}</Box>
                                        {l.test.choices && l.test.choices?.map((c, ic) => (<Box p={2} border={3} my={1}
                                                borderColor={l.test.answer?.includes(ic) ? "#8a9" :
                                                    userAnswers[idx]?.includes(ic) ? "#c96" : "#ccc"
                                                }
                                                bgcolor={l.test.answer?.includes(ic) ? "#efe" :
                                                userAnswers[idx]?.includes(ic) ? "#fee" : "#fff"
                                            }>
                                            {(l.test.answer?.includes(ic) || userAnswers[idx]?.includes(ic)) &&
                                            <Box
                                                px={1} py={0.3} mb={2} ml={2} color={'#eee'}
                                                bgcolor={l.test.answer?.includes(ic) ? "#acb" : "#e96"}
                                                width={l.test.answer?.includes(ic) ? "98px": "115px"}
                                            >
                                                {l.test.answer?.includes(ic) ? "正しい回答": "あなたの回答"}
                                            </Box>}
                                            <Stack direction={'row'} ml={'6px'}>
                                                {!userAnswers[idx]?.includes(ic) ?
                                                    <RadioButtonUncheckedIcon /> :
                                                    l.test.answer?.includes(ic) ?
                                                        <RadioButtonCheckedIcon /> : <CancelIcon />
                                                }
                                                <Box ml={2}>{c.choiceText}</Box>
                                            </Stack>
                                        </Box>))}
                                        <Box ml={'24px'}>解説　{l.test.explanation}</Box>
                                    </AccordionDetails>
                                </Accordion>)}
                            </Box>
                            </>}
                        </Box>
                        <Box sx={{ width: '100%', minHeight:'6rem' }}>
                            {phase === 'test' ? <Box p={1}>
                                <div style={{display: 'inline-block'}}>
                                    <Button
                                        onClick={() => {
                                            if (side === 'practices') {
                                                setSide('tests');
                                            } else {
                                                setSide('practices')
                                            }
                                        }}
                                    >
                                        {side === 'practices' ? '全ての問題を見る' : '問題を隠す'}
                                    </Button>
                                </div>
                                <div style={{display: 'inline-block', float: 'right'}}>
                                    <Button sx={{mr: 2}}
                                        onClick={()=>goBack()}
                                        disabled={tryingNo === 0}
                                    >
                                        戻る
                                    </Button>
                                    {tryingNo + 1 < tests?.length ? <Button
                                        onClick={()=>goNext()}
                                        variant={selectedCoice?.length > 0 ? 'contained':'outlined'}
                                    >
                                        {selectedCoice?.length > 0 ? '次の問題 >':'問題を飛ばす >'}
                                    </Button>
                                    :
                                    <Button
                                        onClick={()=> {
                                            const tmpAnswers: number[][] = [];
                                            for (let i = 0; i < tests?.length; i++) {
                                                if (i === tryingNo) {
                                                    tmpAnswers.push(selectedCoice);
                                                } else {
                                                    tmpAnswers.push(userAnswers[i])
                                                }
                                            } 
                                            setUserAnswers(tmpAnswers);
                                            setOpen(true);
                                        }}
                                        variant={'contained'}
                                    >
                                        {`テストを完了する >`}
                                    </Button>}
                                </div>
                            </Box>
                            :
                            <Box p={1}>
                                <div style={{display: 'inline-block', float: 'right'}}>
                                    {nextId ? <Button sx={{mr: 2}}
                                        href={`/test?no=${nextId}`}
                                    >
                                        続ける
                                    </Button>
                                    :
                                    <Button sx={{mr: 2}}
                                        href={`/home`}
                                    >
                                        戻る
                                    </Button>
                                    }
                                    <Button
                                        href={`/test?no=${practice?.practiceId}`}
                                        variant={selectedCoice?.length > 0 ? 'contained':'outlined'}
                                    >
                                        再テスト
                                    </Button>
                                </div>
                            </Box>}
                        </Box>
                    </Box>
                </Container>
                </Grid>

                {(side === 'practices' || phase !== 'test') && <Grid item xs={12} md={4}>
                    <Container maxWidth='md'>
                        <Box sx={{overflowY: 'scroll', height: '525px'}}>
                            <List sx={{ width: '100%', maxWidth: 380, bgcolor: 'background.paper' }}>
                            {practices && practices?.map((value) => {
                                const labelId = `checkbox-list-label-${value}`;

                                return (
                                <ListItem
                                    key={`p_${value.practiceId}`}
                                    disablePadding
                                    sx={{backgroundColor: '#f8f8f8'}}
                                >
                                    <ListItemButton role={undefined} onClick={()=>{}} dense>
                                    <ListItemIcon>
                                        <Checkbox
                                            edge="start"
                                            disabled
                                            checked={value.triedCount > 0}
                                            tabIndex={-1}
                                            disableRipple
                                            inputProps={{ 'aria-labelledby': labelId }}
                                        />
                                    </ListItemIcon>
                                    <ListItemText id={labelId} primary={value.practiceName} />
                                    </ListItemButton>
                                </ListItem>
                                );
                            })}
                            </List>
                        </Box>
                    </Container>
                </Grid>}
                {(side === 'tests' && phase === 'test') && <Grid item xs={12} md={4}>
                    <Container maxWidth='md'>
                        <Box sx={{overflowY: 'scroll', height: '525px'}}>
                            <List sx={{ width: '100%', maxWidth: 380, bgcolor: 'background.paper' }}>
                            {tests && tests?.map((value, idx) => {
                                const labelId = `checkbox-list-label-${value}`;

                                return (
                                <ListItem
                                    key={`t_${value.testId}`}
                                    disablePadding
                                    sx={{backgroundColor: '#f8f8f8'}}
                                >
                                    <ListItemButton role={undefined} onClick={()=>{}} dense>
                                    <ListItemText
                                        id={labelId}
                                        primary={
                                            <Box>
                                                ☆問題{idx+1}　{userAnswers[idx]?.length === 0 && <Chip label='未回答'/>}
                                            </Box>
                                        }
                                        secondary={
                                            `　${value.question?.length > 20 
                                                ? value.question.substring(0,19) + '...'
                                                : value.question}`
                                        }
                                    />
                                    </ListItemButton>
                                </ListItem>
                                );
                            })}
                            </List>
                        </Box>
                    </Container>
                </Grid>}
            </Grid>
        </UserFrame>
    )
}

export default UserTestTemplate